<main class="atw-container">
  <section class="apply-section" id="cvUploader">
    <div class="section-title">
      <span>{{ 'atw.smartSearch.sectionNumber' | transloco }}</span>

      <div>
        <h2>{{ 'atw.smartSearch.title' | transloco }}</h2>
        <p>{{ 'atw.smartSearch.subtitle' | transloco }}</p>
      </div>
    </div>

    <form
      class="apply-card smart-search-card"
      novalidate
      (submit)="submitCv($event)"
    >
      <div class="smart-stepper">
        <div class="step-pill" [class.active]="currentStep === 'upload'">
          <strong>1</strong>
          <span>{{ 'atw.smartSearch.stepUpload' | transloco }}</span>
        </div>

        <div class="step-line"></div>

        <div class="step-pill" [class.active]="currentStep === 'review'">
          <strong>2</strong>
          <span>{{ 'atw.smartSearch.stepReview' | transloco }}</span>
        </div>
      </div>

      <input
        #fileInput
        id="smart-cv-file"
        type="file"
        accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.doc,.docx"
        hidden
        [disabled]="isUploading"
        (change)="onFileChange($event)"
      />

      <ng-container *ngIf="currentStep === 'upload'">
        <div
          class="pdf-uploader"
          [class.drag-over]="dragOver"
          [class.has-file]="selectedFile"
          (click)="!isUploading && fileInput.click()"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <ng-container *ngIf="!selectedFile">
            <div class="upload-icon">
              <img
                class="img-l"
                src="assets/as/30.webp"
                alt="cv file"
              />
            </div>

            <h3>{{ 'atw.smartSearch.dropTitle' | transloco }}</h3>
            <p>{{ 'atw.smartSearch.dropText' | transloco }}</p>

            <button type="button" class="browse-btn">
              {{ 'atw.smartSearch.chooseCv' | transloco }}

              <img
                class="img-s"
                src="assets/as/6.webp"
                alt="upload"
              />
            </button>
          </ng-container>

          <ng-container *ngIf="selectedFile">
            <div class="file-preview">
              <div class="file-icon">{{ getFileTypeLabel(selectedFile) }}</div>

              <div class="file-info">
                <strong>{{ selectedFile.name }}</strong>
                <span>{{ formatFileSize(selectedFile.size) }}</span>
              </div>

              <button
                type="button"
                class="remove-file"
                [disabled]="isUploading"
                (click)="removeFile($event)"
              >
                ×
              </button>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="currentStep === 'review'">
        <div class="detected-title-card">
          <span>{{ 'atw.smartSearch.detectedData' | transloco }}</span>
          <strong>{{ 'atw.smartSearch.reviewText' | transloco }}</strong>
        </div>

        <div class="form-grid">
          <label>
            <span>{{ 'atw.apply.fullName' | transloco }}</span>
            <input
              type="text"
              [placeholder]="'atw.apply.fullNamePlaceholder' | transloco"
              [value]="form.name"
              [disabled]="isUploading"
              (input)="form.name = $any($event.target).value"
            />
          </label>

          <label>
            <span>{{ 'atw.apply.phoneNumber' | transloco }}</span>
            <input
              type="text"
              inputmode="tel"
              [placeholder]="'atw.apply.phonePlaceholder' | transloco"
              [value]="form.phone"
              [disabled]="isUploading"
              (input)="form.phone = $any($event.target).value"
            />
          </label>

          <label class="full">
            <span>{{ 'atw.apply.emailAddress' | transloco }}</span>
            <input
              type="email"
              [placeholder]="'atw.apply.emailPlaceholder' | transloco"
              [value]="form.email"
              [disabled]="isUploading"
              (input)="form.email = $any($event.target).value"
            />
          </label>

          <label class="full">
            <span>{{ 'atw.smartSearch.detectedTitle' | transloco }}</span>
            <input
              type="text"
              required
              [placeholder]="'atw.smartSearch.titlePlaceholder' | transloco"
              [value]="form.title"
              [disabled]="isUploading"
              (input)="form.title = $any($event.target).value"
            />
          </label>
        </div>

        <div class="file-preview review-file-preview" *ngIf="selectedFile">
          <div class="file-icon">{{ getFileTypeLabel(selectedFile) }}</div>

          <div class="file-info">
            <strong>{{ selectedFile.name }}</strong>
            <span>{{ formatFileSize(selectedFile.size) }}</span>
          </div>

        </div>
      </ng-container>

      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="success-message" *ngIf="successMessage">
        {{ successMessage }}
      </div>

      <div class="upload-progress" *ngIf="isUploading">
        <div class="progress-top">
          <span>{{ 'atw.smartSearch.analyzing' | transloco }}</span>
          <strong>{{ progress }}%</strong>
        </div>

        <div class="progress-track">
          <div class="progress-fill" [style.width.%]="progress"></div>
        </div>
      </div>

      <button
        class="submit-btn"
        type="submit"
        [disabled]="!selectedFile || isUploading"
      >
        <span *ngIf="!isUploading && currentStep === 'upload'">
          {{ 'atw.smartSearch.analyzeButton' | transloco }}
        </span>

        <span *ngIf="!isUploading && currentStep === 'review'">
          {{ 'atw.smartSearch.searchButton' | transloco }}
        </span>

        <span *ngIf="isUploading">
          {{ 'atw.smartSearch.processing' | transloco }}
        </span>
      </button>
    </form>
  </section>
</main>
